import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
var MenuContext = createContext(null);
export var MenuProvider = function (_a) {
    var component = _a.component, children = _a.children;
    return (_jsx(MenuContext.Provider, { value: component, children: children }));
};
export var useMenu = function () {
    var context = useContext(MenuContext);
    if (context === null) {
        throw new Error("useMenu must be used within a MenuProvider");
    }
    return context;
};
//# sourceMappingURL=menuContext.js.map